import { GlButton, GlModal } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import GITLAB_LOGO_SVG_URL from '@gitlab/svgs/dist/illustrations/gitlab_logo.svg?url';
import { __, s__ } from '~/locale';
import { PROMO_URL } from '~/constants';
import { REQUEST_STATE } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/painted_door_request/utils.js?vue3';
import { getTrialActiveFeatures } from 'ee/vue_shared/subscription/components/constants';
import FreeVsPremiumComparisonTable from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/vue_shared/subscription/components/free_vs_premium_comparison_table.vue?vue3';
const SHARED_ROW_IDS = [
    'epics',
    'repositoryPullMirroring',
    'mergeRequestApprovals',
    'mergeTrains',
    'escalationPolicies'
];
const ROWS = [
    {
        id: 'sourceCodeManagement',
        title: s__('ExplorePremium|Source Code Management & CI/CD'),
        freeIncluded: true
    },
    {
        id: 'duoAgentPlatform',
        title: s__('ExplorePremium|GitLab Duo Agent Platform'),
        freeIncluded: false
    },
    ...SHARED_ROW_IDS.map((id)=>({
            id,
            title: getTrialActiveFeatures.find((feature)=>feature.id === id).title,
            freeIncluded: false
        }))
];
export default {
    name: 'ExplorePremiumModal',
    components: {
        GlButton,
        GlModal,
        FreeVsPremiumComparisonTable
    },
    props: {
        visible: {
            type: Boolean,
            required: false,
            default: false
        },
        state: {
            type: String,
            required: true,
            validator: (value)=>Object.values(REQUEST_STATE).includes(value)
        }
    },
    emits: [
        'change',
        'hide',
        'request',
        'learn-more-click'
    ],
    i18n: {
        heading: s__('ExplorePremium|Get more from GitLab'),
        bodyRequest: s__('ExplorePremium|Premium adds more control over reviews, planning, and delivery. Request an upgrade to unlock it for your group.'),
        bodyExplore: s__('ExplorePremium|Premium adds more control over reviews, planning, and delivery. Explore what it has to offer for your group.'),
        requestPremiumFeatures: s__('ExplorePremium|Request Premium features'),
        requested: s__('ExplorePremium|Requested'),
        learnMore: __('Learn more'),
        requestedSupportingText: s__("ExplorePremium|Thank you for your interest in this feature, we've recorded your request. If you need access to Premium features, ask your group Owner to upgrade.")
    },
    gitlabLogoUrl: GITLAB_LOGO_SVG_URL,
    learnMoreUrl: `${PROMO_URL}/pricing/premium`,
    rows: ROWS,
    computed: {
        isRequested () {
            return this.state === REQUEST_STATE.REQUESTED;
        },
        isPreviouslyRequested () {
            return this.state === REQUEST_STATE.PREVIOUSLY_REQUESTED;
        },
        bodyMessage () {
            return this.isPreviouslyRequested ? this.$options.i18n.bodyExplore : this.$options.i18n.bodyRequest;
        },
        learnMoreVariant () {
            return this.isPreviouslyRequested ? 'confirm' : 'default';
        },
        supportingText () {
            return this.isRequested ? this.$options.i18n.requestedSupportingText : '';
        }
    },
    methods: {
        // aria-disabled (kept for the confirm styling) doesn't block clicks.
        handleRequestClick () {
            if (this.isRequested) return;
            this.$emit('request');
        }
    }
};
